import { Box, Tooltip, Typography } from "@mui/material";
import type { UptimeDaily } from "../types/uptime";
import { uptimeBgColor } from "../utils/uptimeStatus";

type UptimeBarChartProps = {
  daily: UptimeDaily[];
  height?: number;
  compact?: boolean;
};

function formatDate(date: string): string {
  const [year, month, day] = date.split("-");
  return `${day}.${month}.${year}.`;
}

export function UptimeBarChart({
  daily,
  height = 96,
  compact = false,
}: UptimeBarChartProps) {
  if (!daily.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Nema podataka o dostupnosti.
      </Typography>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: compact ? "1px" : "2px",
          height,
          width: "100%",
        }}
      >
        {daily.map((day) => (
          <Tooltip
            key={day.date}
            title={
              <Box sx={{ p: 0.5 }}>
                <Typography
                  variant="caption"
                  sx={{ display: "block", fontWeight: 700 }}
                >
                  {formatDate(day.date)}
                </Typography>
                <Typography variant="caption" sx={{ display: "block" }}>
                  {day.uptime == null
                    ? "Nepoznato"
                    : `Dostupnost: ${day.uptime.toFixed(2)}%`}
                </Typography>
                <Typography variant="caption" sx={{ display: "block" }}>
                  Provjere: {day.successfulPings}/{day.attemptedPings}
                  {day.isPartial ? " (danas)" : ""}
                </Typography>
              </Box>
            }
          >
            <Box
              sx={{
                flex: 1,
                minWidth: compact ? 2 : 3,
                height:
                  day.uptime == null ? "12%" : `${Math.max(12, day.uptime)}%`,
                bgcolor: uptimeBgColor(day.uptime, "bar"),
                borderRadius: 0.5,
                transition: "transform 0.15s ease",
                "&:hover": { transform: "scaleY(1.08)", opacity: 0.9 },
              }}
            />
          </Tooltip>
        ))}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 1,
          pt: 1,
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          {formatDate(daily[0].date)}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Danas
        </Typography>
      </Box>
    </Box>
  );
}
